<template>
  <div class="thirdaccesstable">
    <el-table
      :data="tableData"
      style="width: 100%; padding: 10px 10px 0 10px"
      border
    >
      <el-table-column
        prop="createMyAt"
        label="创建时间"
        width="200"
      ></el-table-column>

      <el-table-column
        prop="actionName"
        label="触发动作"
        width="150"
      ></el-table-column>

      <el-table-column prop="bindId" label="创建人" width="280">
        <template slot-scope="scope">
          <span>{{
            scope.row.bindName + " (UID " + scope.row.bindId + " )"
          }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="target" label="回调目标" width="400">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="Top Center 提示文字"
            placement="top"
          >
            <div slot="content" v-html="ToBreak(scope.row.target)"></div>
            <div class="oneLine">{{ scope.row.target }}</div>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column prop="status" label="状态" width="65">
        <template slot-scope="scope">
          <div v-if="scope.row.status !== 0">
            <el-tag type="success">{{ "激活" }}</el-tag>
          </div>

          <div v-if="scope.row.status === 0">
            <el-tag type="danger">{{ "停用" }}</el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="350">
        <template slot-scope="scope">
          <el-button
            @click="closeClick(scope)"
            v-if="scope.row.status !== 0"
            style="color: #f96900; font-weight: bold; font-size: 13px"
            type="text"
            class="btn"
            size="small"
            ><i style="margin-right: 3px" class="el-icon-circle-close"></i
            >停用</el-button
          >
          <el-button
            @click="openClick(scope)"
            v-if="scope.row.status === 0"
            style="color: #13aa65; font-weight: bold; font-size: 13px"
            type="text"
            class="btn"
            size="small"
            ><i style="margin-right: 3px" class="el-icon-document-checked"></i
            >启用</el-button
          >
          <span v-if="scope.row.status === 0" style="margin: 0 11px"> | </span>
          <el-button
            @click="changeClick(scope)"
            v-if="scope.row.status === 0"
            style="color: #13aa65; font-weight: bold; font-size: 13px"
            type="text"
            class="btn"
            size="small"
            ><i style="margin-right: 3px" class="el-icon-folder-checked"></i
            >修改</el-button
          >
          <span style="margin: 0 11px"> | </span>
          <el-button
            @click="callBackRecord(scope)"
            style="color: #185ed3; font-weight: bold; font-size: 13px"
            type="text"
            class="btn"
            size="small"
            ><i style="margin-right: 3px" class="el-icon-link"></i
            >回调记录</el-button
          >
          <!-- <span style="margin:0 11px;"> | </span>
          <el-button @click="testClick(scope)"
                     style="color:#185ED3;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-link"></i>测试</el-button> -->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "thirdaccesstable",
  props: {
    tableData: Array,
  },
  data() {
    return {
      picMsg: {},
      // tableData: [
      // {
      //   date: "2020-04-21",
      //   type: "公开需求",
      //   title: "用在报纸上的图片",
      //   zhang: "152",
      //   ren: "5645"
      // },
      // {
      //   date: "2020-04-21",
      //   type: "定向需求（指定5人）",
      //   title: "用在报纸上的图片",
      //   zhang: "152",
      //   ren: "5645"
      // },
      // {
      //   date: "2020-04-21",
      //   type: "定向需求（指定5人）",
      //   title: "用在报纸上的图片",
      //   zhang: "152",
      //   ren: "5645"
      // },
      // {
      //   date: "2020-04-21",
      //   type: "定向需求（指定5人）",
      //   title: "用在报纸上的图片",
      //   zhang: "152",
      //   ren: "5645"
      // }
      // ]
    };
  },
  methods: {
    changeClick(scope) {
      this.$emit("changeClick", scope.row);
    },
    closeClick(scope) {
      this.$emit("closeClick", scope.row);
    },
    openClick(scope) {
      this.$emit("openClick", scope.row);
    },
    callBackRecord(scope) {
      this.$emit("callBackRecord", scope.row);
    },
    testClick(scope) {
      this.$emit("testClick", scope.row);
    },

    ToBreak(val) {
      let theNew = "";
      if (val.length > 400) {
        theNew = 
          val.substr(0, 100) +
          "<br/>" +
          val.substr(100, 200) +
          "<br/>" +
          val.substr(200, 300) +
          "<br/>" +
          val.substr(300, 400) +
          "<br/>" +
          val.substr(400, val.length - 1);
      } else if (val.length > 300) {
        theNew = 
          val.substr(0, 100) +
          "<br/>" +
          val.substr(100, 150) +
          "<br/>" +
          val.substr(150, 300) +
          "<br/>" +
          val.substr(300, val.length - 1);
      } else if (val.length > 250) {
        theNew =
          val.substr(0, 100) +
          "<br/>" +
          val.substr(100, 200) +
          "<br/>" +
          val.substr(200, val.length - 1);
      } else if (val.length > 150) {
        theNew =
          val.substr(0, 100) +
          "<br/>" +
          val.substr(100, val.length - 1);
      } else {
        theNew = val;
      }

      return theNew;
    },
  },
  created() {},
};
</script>

<style>
.oneLine {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}
.el-tooltip__popper {
  max-width: 800px;
}
.el-table /deep/ .cell .tit:hover {
  text-decoration: underline !important;
}

.oneLine {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
